import React from "react";
import "./Header.css";
import Logo from "../../assets/images/SVG/logo-outline.svg";
import { useNavigate } from "react-router-dom";
// const Logo = require("../../assets/images/SVG/logo.svg") as string;

function Header() {
  const navigate = useNavigate();
  return (
    <div className="header">
      <div className="logo-cont">
        <img className="logo-img" src={Logo} />
        <h1 className="logo-text">telem</h1>
      </div>

      <button
        className="early-access-button"
        onClick={() => navigate("/early-access")}
      >
        Request early access
      </button>
    </div>
  );
}

export default Header;
